
 <div *ngIf="showHeader">
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>
  <app-sidebar [showSidebar]="showSidebar"></app-sidebar>
</div>
<app-loader-interceptor></app-loader-interceptor>
<router-outlet />
